import { TFunction } from 'i18next';
import { TabBarItem } from '@lib/components/TabBar/constants';

type Args = {
  t: TFunction<'translation', undefined>;
  isSitesAvailable: boolean;
  sectorsCount?: number;
  sitesCount?: number;
};

export default function getAccessesTabs({
  t,
  isSitesAvailable,
  sectorsCount,
  sitesCount,
}: Args): TabBarItem[] {
  const tabs: TabBarItem[] = [];
  // Sectors and Sites both fall under SitesManagement (see getSitesNavItem.ts).
  if (isSitesAvailable) {
    tabs.push({
      label: t('sectors'),
      value: 'sectors',
      counter: sectorsCount,
    });
    tabs.push({
      label: t('sites'),
      value: 'sites',
      counter: sitesCount,
    });
  }
  return tabs;
}
